import { getRgObjectsOfType as l, RG_TYPE as f } from "@project-rouge/rg-core";
import { getBuildingChildrenAtLevel as c } from "../../../utils/rg-util/index.js";
import { getArea as d } from "../index3.js";
const p = (r, i, n) => {
  const e = l(r, f.Building);
  if (e.length <= 0)
    return 0;
  let t = 0;
  for (const o of e) {
    const g = c(o, i, n);
    t += d(g);
  }
  return t;
};
export {
  p as getLevelArea
};
//# sourceMappingURL=index4.js.map
